module.exports = __webpack_public_path__ + "img/guofa2.c4f61118.png";